import { useDispatch } from 'react-redux';
import A from './ActionCreators';
export default function ImageAdjustmentSlider({
  label,property,min,max,step,imageId,
  onChange,value,setTemporaryAdjustments
}){

  let dispatch = useDispatch();

  let valueToDisplay;
  if( value >= 1 ){
    valueToDisplay = (value - 1)/(max*2) + 0.5;
  }else{
    valueToDisplay = value / 2;
  }


  const onInputChange = e => {
    let newValue = Number(e.target.value);
    if( newValue < 0.5 ){
      onChange( newValue * 2 );
    }else if( newValue >= 0.5 ){
      onChange((newValue - 0.5)*2*max + 1);
    }
  }

  return (
  <div class="sg-row rel">
    <div style={{width:80}}>
    {label||"Unlabeled property"}
    </div>

    {false && <input class="wide-slider " onMouseUp={() => {
      setTemporaryAdjustments({});
      dispatch(A.setImageProperty({imageId,property,value}));
    }} value={valueToDisplay} onChange={onInputChange}
      type="range" {...{
        min:1e-10,max:1,step:'any',
        //width:10,
        //flex:'expand',
      }}/>}

    <div>{false && "(value: " + value+")"}</div>
    <div>{false && "(valueToDisplay: "+valueToDisplay+")"}</div>

    <input 
      onChange={onInputChange}
      step={0.01}
      style={{
      width:60
    }} type="number" value={Number(Number(valueToDisplay).toFixed(3))}/>

  </div>
  )


}
